// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { PersonNameResponse } from './person-name-response';

// @ts-ignore
import { ReferenceDataSummaryResponse } from './reference-data-summary-response';

/** See com.rev360.pms.api.controller.patient.pod.PatientPodContactResponse */
/* istanbul ignore next */
@GandalfModel
export class PatientPodContactResponse extends GandalfModelBase {

	@GandalfProperty({ designType: Number })
	contactId!: number | null;

	@GandalfProperty({ designType: String })
	email!: string | null;

	@GandalfProperty({ designType: PersonNameResponse })
	name!: PersonNameResponse | null;

	@GandalfProperty({ designType: String })
	phone!: string | null;

	@GandalfProperty({ designType: ReferenceDataSummaryResponse })
	role!: ReferenceDataSummaryResponse | null;

}
